<style>
.responsive-datepicker .dropdown-menu {
    left: auto !important;
    right: 0 !important;
    transform-origin: top right;
}

@media (min-width: 1280px) {
    .responsive-datepicker .dropdown-menu {
        left: auto !important;
        right: 9% !important;
        transform-origin: top right;
    }
}

#inputFile .invalid-feedback {
    display: flex;
}

#inputFile .custom-file-label {
    margin-top: 0px;
}

.parent-icon {
    width: 25px;
    height: 25px;
    color: #4966a2;
}

.parent-icon--female {
    color: #942576;
}
</style>
<template>
    <b-overlay>
        <b-card style="background-color: #fff;" id="container-production-line">
            <ValidationObserver ref="observer" v-slot="{ passes }">
                <b-form @submit.prevent="passes(saveProductionLine)" id="production-line-form">
                    <b-row class="mb-2">
                        <b-col md="2" sm="12">
                            <ValidationProvider rules="integer|min_value:1" v-slot="{ errors }">
                                <b-form-group label="Hybrid batch" :invalid-feedback="errors[0]">
                                    <b-form-input v-model="productionLine.hybridBatch" autocomplete="false" 
                                                  :state="errors[0] ? false : null"></b-form-input>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col md="2" sm="12">
                            <ValidationProvider rules="required" v-slot="{ errors }">
                                <b-form-group label="Variety" :invalid-feedback="errors[0]" :state="errors[0] ? false : null">
                                    <v-select label="text" :options="varieties" @search="getVarieties" @search:focus="getVarieties"
                                              v-model="productionLine.variety" :filterable="false" :disabled="productionLine.productionLineOccupancy !== null"
                                              placeholder="Select variety" :state="errors[0] ? false : null">
                                        <template #no-options>No results</template>
                                    </v-select>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col md="2" sm="12">
                            <ValidationProvider rules="required" v-slot="{ errors }">
                                <b-form-group label="Crop" :invalid-feedback="errors[0]">
                                    <b-form-input v-model="productionLine.crop" autocomplete="false" disabled
                                                  :state="errors[0] ? false : null"></b-form-input>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col md="2" sm="12">
                            <ValidationProvider rules="required" v-slot="{ errors }">
								<b-form-group label="Year" :invalid-feedback="errors[0]">
									<custom-year-datepicker :container="'#container-production-line'" v-model="productionLine.orderYear" :state="errors[0] ? false : null" />
								</b-form-group>
							</ValidationProvider>
                        </b-col>
                        <b-col md="2" sm="12">
                            <ValidationProvider rules="required|integer|min_value:1" v-slot="{ errors }">
                                <b-form-group label="Season" :invalid-feedback="errors[0]">
                                    <b-form-input v-model="productionLine.season" autocomplete="false"
                                                  :state="errors[0] ? false : null"></b-form-input>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col md="2" sm="12">
                            <ValidationProvider rules="required|integer|min_value:1" v-slot="{ errors }">
                                <b-form-group label="Review" :invalid-feedback="errors[0]">
                                    <b-form-input v-model="productionLine.sequence" autocomplete="false"
                                                  :state="errors[0] ? false : null"></b-form-input>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                    <b-row>
                         <b-col md="2" sm="12">
                            <b-form-group label="Crop number">
                                <b-form-input v-model="productionLine.cropNumber" autocomplete="false"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col md="2" sm="12">
                            <b-form-group label="Contract number">
                                <b-form-input v-model="productionLine.contractNumber" autocomplete="false"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col md="2" sm="12">
                            <b-form-group label="Order">
                                <b-form-input v-model="productionLine.orderId" autocomplete="false"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col md="2" sm="12">
                            <b-form-group label="Type">
                                <v-select label="title" :options="types" @search:focus="getVarieties" @search="getVarieties"
                                          :reduce="type => type.id" v-model="productionLine.type"
                                          placeholder="Select type" >
                                    <template #no-options>No results</template>
                                </v-select>
                            </b-form-group>
                        </b-col>
                        <b-col md="2" sm="12">
                            <b-form-group label="BIO/GSPP">
                                <v-select label="text" v-model="productionLine.bioGspp" :options="['BIO', 'GSPP']">
                                </v-select>
                            </b-form-group>
                        </b-col>
                        <b-col md="2" sm="12">
                            <b-form-group label="MS (%)">
                                <b-form-input v-model="productionLine.productionLineMs" autocomplete="false"></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="2" sm="12">
                            <b-form-group label="MS">
                                <v-select label="text" v-model="productionLine.msVariety" :options="['1 Non sterile', '2 Sterile']">
                                </v-select>
                            </b-form-group>
                        </b-col>
                        <b-col md="2" sm="12">
                             <ValidationProvider rules="integer|min_value:0|max_value:10" v-slot="{ errors }">
                                <b-form-group label="Current phase" :invalid-feedback="errors[0]">
                                    <b-form-input v-model="productionLine.currentPhase" :state="errors[0] ? false : null" autocomplete="off"></b-form-input>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col md="2" sm="12">
                            <b-form-group label="Pollination type">
                                <v-select label="text" :options="pollinationType" @search:focus="getPollinationType" @search="getPollinationType"
                                            v-model="productionLine.pollinationType" placeholder="Select pollination">
                                    <template #no-options>No results</template>
                                </v-select>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="2" sm="12">
                            <ValidationProvider rules="required" v-slot="{ errors }">
                                <b-form-group label="Female parent" :invalid-feedback="errors[0]">
                                    <b-form-input v-model="productionLine.parentalFemaleName" autocomplete="false" disabled
                                                  :state="errors[0] ? false : null"></b-form-input>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                         <b-col md="2" sm="12">
                            <ValidationProvider rules="number|min_value:0" v-slot="{ errors }">
                                <b-form-group label="Germination NL% female" :invalid-feedback="errors[0]">
                                    <b-form-input v-model="productionLine.germinationPercentFemale" autocomplete="false"
                                                  :state="errors[0] ? false : null"></b-form-input>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col md="3" sm="12">
                            <b-form-group label="Invoice numbers female">
                                <Batches v-model="productionLine.invoiceNumbersFemale" style="width: 100%; min-height: 16px;" state></Batches>
                            </b-form-group>
                        </b-col>
                        <!-- <b-col md="2" sm="12">
                            <b-form-group label="PLD (female)">
                                <b-form-input v-model="productionLine.femalePld" autocomplete="false"></b-form-input>
                            </b-form-group>
                        </b-col> -->
                        <b-col md="12">
                            <b-form-group label="Remarks stockseed female">
                                <b-form-textarea v-model="productionLine.remarkStockseedFemale" rows="3"></b-form-textarea>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="2" sm="12">
                            <ValidationProvider rules="required" v-slot="{ errors }">
                                <b-form-group label="Male parent" :invalid-feedback="errors[0]">
                                    <b-form-input v-model="productionLine.parentalMaleName" autocomplete="false" disabled
                                                  :state="errors[0] ? false : null"></b-form-input>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col md="2" sm="12">
                            <ValidationProvider rules="number|min_value:0" v-slot="{ errors }">
                                <b-form-group label="Germination NL% male" :invalid-feedback="errors[0]">
                                    <b-form-input  v-model="productionLine.germinationPercentMale" autocomplete="false"
                                                  :state="errors[0] ? false : null"></b-form-input>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col md="3" sm="12">
                            <b-form-group label="Invoice numbers male">
                                <Batches v-model="productionLine.invoiceNumbersMale" style="width: 100%; min-height: 16px;" state></Batches>
                            </b-form-group>
                        </b-col>
                        <!--<b-col md="2" sm="12">
                            <b-form-group label="PLD (male)">
                                <b-form-input v-model="productionLine.malePld" autocomplete="false"></b-form-input>
                            </b-form-group>
                        </b-col> -->
                        <b-col md="12">
                            <b-form-group label="Remarks stockseed male">
                                <b-form-textarea v-model="productionLine.remarkStockseedMale" rows="3"></b-form-textarea>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="12" sm="12" class="mt-3 mb-3">
                            <ValidationProvider rules="pdf" v-slot="{ errors }">
                                <b-form-group label="PLD file" id="inputFile" :invalid-feedback="errors[0]" >
                                    <b-input-group>
                                        <b-input-group-prepend>
                                            <b-button @click="clearFile" variant="danger" v-if="filePld || productionLine.filePdlId"><font-awesome-icon icon="times"></font-awesome-icon></b-button>
                                        </b-input-group-prepend>
                                        <b-form-file  v-model="filePld" accept=".pdf" :state="errors[0] ? false : null" :placeholder="productionLine.filePdlName ? productionLine.filePdlName : 'Choose a file or drop it here...'">
                                        </b-form-file>
                                    </b-input-group>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="2" sm="12">
							<ValidationProvider v-slot="{ errors }">
								<b-form-group label="Change date" :invalid-feedback="errors[0]">
									<custom-datepicker :container="'#container-production-line'" v-model="productionLine.changeDate" :state="errors[0] ? false : null" />
								</b-form-group>
							</ValidationProvider>
                        </b-col>
                        <b-col md="2" sm="12">
                            <ValidationProvider v-slot="{ errors }" rules="required|number|min_value:0.01">
                                <b-form-group label="Order kg" :invalid-feedback="errors[0]">
                                    <b-form-input v-model="productionLine.orderKg" autocomplete="false" :disabled="productionLine.id > 0 && (productionLine.parentId > 0 || productionLine.children.length > 0)"
                                                  :state="errors[0] ? false : null"></b-form-input>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col md="2" sm="12">
                            <ValidationProvider v-slot="{ errors }" rules="required|number|min_value:0">
                                <b-form-group label="Yield NL (g/pl)" :invalid-feedback="errors[0]">
                                    <b-form-input v-model="productionLine.yieldNl" autocomplete="false"
                                                  :state="errors[0] ? false : null"></b-form-input>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col md="2" sm="12">
                            <b-form-group label="kg/ha, g/plant">
                                <v-select label="text" v-model="productionLine.yieldUnits" :options="['kg/ha', 'g/plant']">
                                </v-select>
                            </b-form-group>
                        </b-col>
                        <b-col md="2" sm="12">
                            <ValidationProvider v-slot="{ errors }" rules="integer|min_value:1">
                                <b-form-group label="Female nr. of plants net" :invalid-feedback="errors[0]">
                                    <b-form-input v-model="productionLine.femalePlantsNl" autocomplete="false"
                                                  :state="errors[0] ? false : null"></b-form-input>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <!-- <b-col md="2" sm="12">
                            <b-form-group label="Prod. area (m²)">
                                <b-form-input v-model="productionLine.productionArea" autocomplete="false"></b-form-input>
                            </b-form-group>
                        </b-col> -->
                        <b-col md="2" sm="12">
                            <b-form-group label="Growth tech">
                                <v-select label="text" v-model="productionLine.growthTech" :options="['Modulair', 'No modulair']">
                                </v-select>
                            </b-form-group>
                        </b-col>
                        <!-- <b-col md="2" sm="12">
                            <b-form-group label="Location">
                                <b-form-input v-model="productionLine.location" autocomplete="false"></b-form-input>
                            </b-form-group>
                        </b-col> -->
                        <b-col md="12">
                            <b-form-group label="Remarks">
                                <b-form-textarea v-model="productionLine.remarks" rows="3"></b-form-textarea>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="2" sm="12">
                            <b-form-group label="Priority">
                                <v-select label="text" v-model="productionLine.priority" :options="['True', 'False']">
                                </v-select>
                            </b-form-group>
                        </b-col>
                        <b-col md="2" sm="12">
							<ValidationProvider v-slot="{ errors }">
								<b-form-group label="Delivery seeds date" :invalid-feedback="errors[0]">
									<custom-datepicker :container="'#container-production-line'" v-model="productionLine.deliverDate" :state="errors[0] ? false : null" />
								</b-form-group>
							</ValidationProvider>
                        </b-col>
                        <b-col md="2" sm="12">
							<ValidationProvider v-slot="{ errors }">
								<b-form-group label="Ultimate seeds date" :invalid-feedback="errors[0]">
									<custom-datepicker :container="'#container-production-line'" v-model="productionLine.ultimateShipmentDate" :state="errors[0] ? false : null" />
								</b-form-group>
							</ValidationProvider>
                        </b-col>
                        <b-col md="2" sm="12">
                            <ValidationProvider v-slot="{ errors }" rules="number|min_value:0.01">
                                <b-form-group label="Yield calculated (kg)" :invalid-feedback="errors[0]">
                                    <b-form-input v-model="productionLine.yieldCalculated" autocomplete="false"
                                        :state="errors[0] ? false : null"></b-form-input>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col md="2" sm="12">
                            <ValidationProvider v-slot="{ errors }" rules="number|min_value:0.01">
                                <b-form-group label="Ratio" :invalid-feedback="errors[0]">
                                    <b-form-input v-model="productionLine.malePerFemaleRatio" autocomplete="false" disabled
                                                  :state="errors[0] ? false : null"></b-form-input>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col md="2" sm="12">
                            <ValidationProvider v-slot="{ errors }" rules="number|min_value:0.01">
                                <b-form-group label="Density (pl/m²)" :invalid-feedback="errors[0]">
                                    <b-form-input v-model="productionLine.density" autocomplete="false"
                                                  :state="errors[0] ? false : null"></b-form-input>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <!-- <b-col md="2" sm="12">
                            <ValidationProvider v-slot="{ errors }" rules="integer|min_value:0">
                                <b-form-group label="Females needed" :invalid-feedback="errors[0]">
                                    <b-form-input v-model="productionLine.femalePlantsMx" autocomplete="false"
                                                  :state="errors[0] ? false : null"></b-form-input>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col md="2" sm="12">
                            <ValidationProvider v-slot="{ errors }" rules="integer|min_value:0">
                                <b-form-group label="Males needed" :invalid-feedback="errors[0]">
                                    <b-form-input v-model="productionLine.malesNeeded" autocomplete="false"
                                                  :state="errors[0] ? false : null"></b-form-input>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col> 
                        <b-col md="2" sm="12">
                            <ValidationProvider v-slot="{ errors }">
                                <b-form-group label="Total plants">
                                    <b-form-input v-model="productionLine.totalPlants" autocomplete="false" disabled
                                                  :state="errors[0] ? false : null"></b-form-input>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col> -->
                        <b-col md="2" sm="12">
                            <ValidationProvider v-slot="{ errors }" rules="integer|min_value:0">
                                <b-form-group label="Plants per line" :invalid-feedback="errors[0]">
                                    <b-form-input v-model="productionLine.plantsPerLine" autocomplete="false"
                                                  :state="errors[0] ? false : null"></b-form-input>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <!-- <b-col md="2" sm="12">
                            <ValidationProvider v-slot="{ errors }" rules="required|number|min_value:0.01">
                                <b-form-group label="Rows required" :invalid-feedback="errors[0]">
                                    <b-form-input v-model="productionLine.rowsRequired" autocomplete="false" :disabled="productionLine.productionLineOccupancy !== null"
                                                  :state="errors[0] ? false : null"></b-form-input>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col> -->
                        <!-- <b-col md="2" sm="12">
                            <ValidationProvider v-slot="{ errors }" rules="required|number|min_value:0.01">
                                <b-form-group label="Surface req. (m²)" :invalid-feedback="errors[0]">
                                    <b-form-input v-model="productionLine.surfaceRequired" autocomplete="false" :disabled="productionLine.productionLineOccupancy !== null"
                                                  :state="errors[0] ? false : null"></b-form-input>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col> -->
                        <b-col md="2" sm="12">
							<ValidationProvider v-slot="{ errors }" rules="required">
								<b-form-group label="Order date" :invalid-feedback="errors[0]">
									<custom-datepicker :container="'#container-production-line'" v-model="productionLine.orderDate" :state="errors[0] ? false : null" />
								</b-form-group>
							</ValidationProvider>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="6" sm="12">
                            <b-table-simple responsive bordered class="mt-4">
                                <b-thead>
                                    <b-tr>
                                        <b-th class="text-center">Parent</b-th>
                                        <b-th class="text-center">Plants needed</b-th>
                                        <b-th class="text-center">Rows required</b-th>
                                    </b-tr>
                                </b-thead>
                                <b-tbody>
                                    <b-tr>
                                        <b-td>
                                            <div class="d-flex justify-content-center align-items-center">
                                                <font-awesome-icon icon="mars" class="parent-icon"></font-awesome-icon>&nbsp;{{ productionLine.parentalMaleName }}
                                            </div>
                                        </b-td>
                                        <b-td>
                                            <ValidationProvider v-slot="{ errors }" rules="integer|min_value:0">
                                                <b-form-group :invalid-feedback="errors[0]">
                                                    <b-form-input v-model="productionLine.malesNeeded" autocomplete="false"
                                                                :state="errors[0] ? false : null"></b-form-input>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-td>
                                        <b-td>
                                            <ValidationProvider v-slot="{ errors }" :rules="productionLine.productionLineOccupancy !== null ? 'number|min_value:0.01' : 'required|number|min_value:0.01'">
                                                <b-form-group :invalid-feedback="errors[0]">
                                                    <b-form-input v-model="productionLine.rowsRequiredMale" autocomplete="false" disabled
                                                                :state="errors[0] ? false : null"></b-form-input>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-td>
                                    </b-tr>
                                    <b-tr>
                                        <b-td>
                                            <div class="d-flex justify-content-center align-items-center">
                                                <font-awesome-icon icon="venus" class="parent-icon parent-icon--female"></font-awesome-icon>&nbsp;{{ productionLine.parentalFemaleName }}
                                            </div>
                                        </b-td>
                                        <b-td>
                                            <ValidationProvider v-slot="{ errors }" rules="integer|min_value:0">
                                                <b-form-group :invalid-feedback="errors[0]">
                                                    <b-form-input v-model="productionLine.femalePlantsMx" autocomplete="false"
                                                                :state="errors[0] ? false : null"></b-form-input>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-td>
                                        <b-td>
                                            <ValidationProvider v-slot="{ errors }" :rules="productionLine.productionLineOccupancy !== null ? 'number|min_value:0.01' : 'required|number|min_value:0.01'">
                                                <b-form-group :invalid-feedback="errors[0]">
                                                    <b-form-input v-model="productionLine.rowsRequiredFemale" autocomplete="false" disabled
                                                                :state="errors[0] ? false : null"></b-form-input>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-td>
                                    </b-tr>
                                </b-tbody>
                                <b-tfoot>
                                    <b-tr>
                                        <b-td class="text-right font-weight-bold">Total</b-td>
                                        <b-td class="text-right font-weight-bold">{{ productionLine.totalPlants }}</b-td>
                                        <b-td class="text-right font-weight-bold">{{ productionLine.rowsRequired }}</b-td>
                                    </b-tr>
                                    <b-tr v-if="isOldProductionLine">
                                        <b-td class="text-left" colspan="3" style="color: #006d7b;">* Fill in rows required information for male and female (original <strong style="color: #006d7b;">"rows required"</strong> value: <strong style="color: #006d7b;">{{ rowsRequiredOriginal }}</strong>)</b-td>
                                    </b-tr>
                                </b-tfoot>
                            </b-table-simple>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="4" sm="12">
                            <ValidationProvider rules="required" v-slot="{ errors }">
                                <b-form-group label="Location" :invalid-feedback="errors[0]" :clearable="false" :state="errors[0] ? false : null">
                                    <v-select :options="compartments"  @search:focus="getCompartments" @search="getCompartments" multiple @input="filterCompartments" :disabled="productionLine.productionLineOccupancy !== null"
                                            v-model="productionLine.location" label="text" placeholder="Select compartment">
                                        <template #no-options>No results</template>
                                    </v-select>
                                </b-form-group>  
                            </ValidationProvider>  
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col ms="12" sm="12">
                            <b-table-simple responsive bordered class="mt-4">
                                <b-thead>
                                    <b-tr>
                                        <b-th class="text-center">Location</b-th>
                                        <b-th class="text-center">Rows required male</b-th>
                                        <b-th class="text-center">Rows required female</b-th>
                                        <b-th class="text-center">Total rows required</b-th>
                                        <b-th class="text-center">Row Net Surface (m²)</b-th>
                                        <b-th class="text-center">Surface required (m²)</b-th>
                                    </b-tr>
                                </b-thead>
                                <b-tbody>
                                    <b-tr v-for="(location, index) in productionLine.location" :key="index">
                                        <b-td class="text-center">{{ location.text }}</b-td>
                                        <b-td>
                                            <ValidationProvider v-slot="{ errors }" :rules="productionLine.productionLineOccupancy !== null ? 'number|min_value:0' : 'required|number|min_value:0'">
                                                <b-form-group :invalid-feedback="errors[0]">
                                                    <b-form-input v-model="location.rowsRequiredMale" autocomplete="false" @input="calculateLocationData(location)" :disabled="productionLine.productionLineOccupancy !== null" :state="errors[0] ? false : null"></b-form-input>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-td>
                                         <b-td>
                                            <ValidationProvider v-slot="{ errors }" :rules="productionLine.productionLineOccupancy !== null ? 'number|min_value:0' : 'required|number|min_value:0'">
                                                <b-form-group :invalid-feedback="errors[0]">
                                                    <b-form-input v-model="location.rowsRequiredFemale" autocomplete="false" @input="calculateLocationData(location)" :disabled="productionLine.productionLineOccupancy !== null" :state="errors[0] ? false : null"></b-form-input>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-td>
                                        <b-td class="text-right">{{ location.totalRowsRequired }}</b-td>
                                        <b-td class="text-right">{{ location.compartmentRowNetSurface ? (location.compartmentRowNetSurface).toFixed(2) : null }}</b-td>
                                        <b-td class="text-right">{{ location.surfaceRequired }}</b-td>
                                    </b-tr>
                                </b-tbody>
                                <b-tfoot>
                                    <b-tr>
                                        <b-td class="text-right font-weight-bold">Total</b-td>
                                        <b-td class="text-right font-weight-bold">{{ productionLine.rowsRequiredMale }}</b-td>
                                        <b-td class="text-right font-weight-bold">{{ productionLine.rowsRequiredFemale }}</b-td>
                                        <b-td class="text-right font-weight-bold">{{ productionLine.rowsRequired }}</b-td>
                                        <b-td></b-td>
                                        <b-td class="text-right font-weight-bold">{{ productionLine.surfaceRequired }}</b-td>
                                    </b-tr>
                                </b-tfoot>
                            </b-table-simple>
                        </b-col>
                    </b-row>
                </b-form>
            </ValidationObserver>
            <template #footer>
                <div class="text-right">
                    <b-button variant="outline-secondary" :to="{ name: 'ProductionLineIndex' }" class="mr-2"><font-awesome-icon icon="angle-left"></font-awesome-icon> Back</b-button>
                    <b-button variant="secondary" :to="{ name: 'ProductionLineShow', params: { id: productionLine.id, variety: productionLine.variety.text }}" v-if="productionLine.id" class="mr-2">
                        <font-awesome-icon icon="search"></font-awesome-icon> Detail
                    </b-button>
                    <b-button type="submit" form="production-line-form" variant="primary"><font-awesome-icon icon="save"></font-awesome-icon> Save</b-button>
                </div>
            </template>
        </b-card>
    </b-overlay>
</template>

<script>
import { extend } from 'vee-validate';
import { integer, min_value, required, max_value } from 'vee-validate/dist/rules';
import { getProductionLineByIdUrl, getVarietyByIdUrl, productionLineSaveUrl, varietiesSelectUrl, varietyPollinationTypeSelectUrl, compartmentsSelectUrl } from '@routes';
import { ProductionLineEntity } from '@/models/productionLineEntity';
import Utilities, { formatDate } from '@/js/utilities';
import customDatepicker from '@components/customDatepicker.vue';
import customYearDatepicker from '@components/customYearDatepicker.vue';
import Batches from '@components/batches.vue';
import 'bootstrap-datepicker';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.css';

extend('required', {
    ...required,
    message: 'Field required'
});

extend('number', value => {
    if (Utilities.isNumeric(value)) {
        return true;
    }
    return 'Must be number';
});

extend('pdf', value => {
    if (value.type == 'application/pdf') {
        return true;
    }
    return 'Must be pdf file';
});

extend('integer', {
    ...integer,
    message: 'Must be integer'
});

extend('min_value', {
    ...min_value,
    message: 'Must be greater'
});

extend('max_value', {
    ...max_value,
    message: 'The value must be between 1 to 10'
});

export default {
    components: { customDatepicker, customYearDatepicker, Batches },
    data() {
        return {
            productionLine: ProductionLineEntity.create(),
            swalTitle: 'Production lines',
            breadcrumb: {
                title: 'Production lines',
                path: [
                    {
                        name: 'ProductionLineIndex',
                        text: 'Production lines'
                    }
                ]
            },
            action: 'Add',
            signature: null,
            oldSignature: null,
            isLoading: false,
            file: null,
            varieties: [],
            toastTitle: 'Production lines',
            types:[
                {
                    id: 'BREEDING',
                    title: 'Breeding'
                },
                {
                    id: 'BUFFER',
                    title: 'Buffer'
                },
                {
                    id: 'COMMERCIAL',
                    title: 'Commercial'
                },
                {
                    id: 'FREE_PROGRAM',
                    title: 'Free program'
                },
                {
                    id: 'TRIAL',
                    title: 'Trial'
                }
            ],
            filePld: null,
            fileDeleted: false,
            rowsRequiredOriginal: '',
            isOldProductionLine: false,
            pollinationType: [],
            compartments: []
        };
    },
    created() {
        if (!this.$route.name.includes('Edit')) {
            this.breadcrumb.path.push({
                name: this.$route.name,
                text: `${this.action}`
            });

            this.$emit('update-breadcrumb', this.breadcrumb);
        } else {
            this.loadData();
        }
    },
    methods: {
        showInfoBreadCrumb() {
            if (this.$route.name.includes('Edit')) {
                let text = '';

                text += this.productionLine.varietyName + (this.productionLine.tag ? '-' + this.productionLine.tag : '');

                this.action = `${ text } / Edit`;

                this.breadcrumb.path.push({
                    name: this.$route.name,
                    text: `${this.action}`
                });

                this.$emit('update-breadcrumb', this.breadcrumb);
            }
        },
        calculateLocationData(location) {
            if (location.rowsRequiredFemale && location.rowsRequiredMale) {
                location.totalRowsRequired = (Number(location.rowsRequiredFemale) + Number(location.rowsRequiredMale)).toFixed(2);
                location.surfaceRequired = (location.totalRowsRequired * location.compartmentRowNetSurface).toFixed(2);
            } else {
                location.totalRowsRequired = null;
                location.surfaceRequired = null;
            }
        },
        loadData() {
            this.isLoading = true;

            let $this =  this;

            this.axios.get(getProductionLineByIdUrl(this.$route.params.id)).then(response => {
                this.productionLine = JSON.parse(JSON.stringify(response.data.productionLine));
                this.productionLine.orderYear =  String(this.productionLine.orderYear);
                this.rowsRequiredOriginal =  this.productionLine.rowsRequired;
                if (this.rowsRequiredOriginal && !this.productionLine.rowsRequiredFemale && !this.productionLine.rowsRequiredMale && this.productionLine.processStageId <= 5) {
                    this.isOldProductionLine = true;
                }

                this.productionLine.location.forEach(function(item) {  
                    $this.calculateLocationData(item);
                });

                this.$nextTick(() => {
                    this.formatDatepicker(this.productionLine.orderDate, 'orderDate');
                    this.formatDatepicker(this.productionLine.ultimateShipmentDate, 'ultimateSeedsDate');
                    this.formatDatepicker(this.productionLine.deliverDate, 'deliverySeedsDate');
                    this.formatDatepicker(this.productionLine.changeDate, 'changeDate');
                });
            }).catch(error => {
                if (error.response) {
                    this.$bvToast.toast(error.response.data.message, {
                        title: this.toastTitle,
                        variant: 'danger'
                    });
                } else if (error.request) {
                    this.$bvToast.toast('An error occurred while executing the request', {
                        title: this.toastTitle,
                        variant: 'danger'
                    });
                } else {
                    this.$bvToast.toast('An error occurred while configuring the request', {
                        title: this.toastTitle,
                        variant: 'danger'
                    });
                }
            }).finally(() => {
                this.isLoading = false;

                this.$nextTick(() => {
                    this.showInfoBreadCrumb();
                });
            });
        },
        saveProductionLine() {
            let formData = new FormData();

            formData.append('productionLine', JSON.stringify(this.productionLine));
            formData.append('file', this.filePld);
            formData.append('fileDeleted', this.fileDeleted);

            this.isLoading = true;

            this.axios.post(productionLineSaveUrl(), formData).then(response => {
                if (response.status === 200 && response.data.code == 'OK') {
                    this.$bvToast.toast(response.data.message, {
                        title: this.toastTitle,
                        variant: 'success'
                    });
                    this.$router.push({
                        name: 'ProductionLineShow',
                        params:
                        {
                            id: response.data.id,
                            successMessage: response.data.message,
                            variety: response.data.varietyName
                        }
                    });
                } else {
                    this.$bvToast.toast(response.data.message, {
                        title: this.toastTitle,
                        variant: 'danger'
                    });
                }
            }).catch(error => {
                if (error.response) {
                    this.$bvToast.toast(error.response.data.message, {
                        title: this.toastTitle,
                        variant: 'danger'
                    });
                } else if (error.request) {
                    this.$bvToast.toast('An error occurred while executing the request', {
                        title: this.toastTitle,
                        variant: 'danger'
                    });
                } else {
                    this.$bvToast.toast('An error occurred while configuring the request', {
                        title: this.toastTitle,
                        variant: 'danger'
                    });
                }
            }).finally(() => {
                this.isLoading = false;
            });
        },
        getVarieties(text, loading) {
            if (loading) {
                loading(true);
            }

            this.varieties = [];
            this.axios.post(varietiesSelectUrl(), {
                search: text
            }).then(response => {
                this.varieties = response.data.variety;
            }).catch(error => {
                if (error.response) {
                    this.$bvToast.toast(error.response.data.message, {
                        title: this.toastTitle,
                        variant: 'danger'
                    });
                } else if (error.request) {
                    this.$bvToast.toast('An error occurred while executing the request', {
                        title: this.toastTitle,
                        variant: 'danger'
                    });
                } else {
                    this.$bvToast.toast('An error occurred while configuring the request', {
                        title: this.toastTitle,
                        variant: 'danger'
                    });
                }
            }).finally(() => {
                if (loading) {
                    loading(false);
                }
            });
        },
        formatDatepicker(value, ref) {
            if (value) {
                this.$nextTick(() => {
                    this.$refs[ref].formattedValue = formatDate(value);
                });
            }
        },
        clearFile() {
            this.filePld = null;
            this.productionLine.filePdlId = null;
            this.productionLine.filePdlName = null;
            this.fileDeleted = true;
        },
        getPollinationType(search, loading) {
            if (loading) {
                loading(true);
            }
            this.axios.get(varietyPollinationTypeSelectUrl()).then(response => {
                this.pollinationType = response.data.types;
            }).catch(error => {
                if (error.response) {
                    this.$bvToast.toast(error.response.data.message, {
                        title: this.toastTitle,
                        variant: 'danger'
                    });
                } else if (error.request) {
                    this.$bvToast.toast('An error occurred while executing the request', {
                        title: this.toastTitle,
                        variant: 'danger'
                    });
                } else {
                    this.$bvToast.toast('An error occurred while configuring the request', {
                        title: this.toastTitle,
                        variant: 'danger'
                    });
                }
            }).finally(() =>{
                if (loading) {
                    loading(false);
                }
            });
        },
        filterCompartments() {
            let locationIds = this.productionLine.location.map(location => parseInt(location.value));
            this.compartments = this.compartments.filter(compartment => !locationIds.includes(parseInt(compartment.value)));
        },
        getCompartments(search, loading) {
            if (loading) {
                loading(true);
            }
            this.axios.post(compartmentsSelectUrl(), {
                search: search
            }).then(response => {
                this.compartments = response.data.compartments;
                this.filterCompartments();
            }).catch(error => {
                if (error.response) {
                    this.$bvToast.toast(error.response.data.message, {
                        title: this.toastTitle,
                        variant: 'danger'
                    });
                } else if (error.request) {
                    this.$bvToast.toast('An error occurred while executing the request', {
                        title: this.toastTitle,
                        variant: 'danger'
                    });
                } else {
                    this.$bvToast.toast('An error occurred while configuring the request', {
                        title: this.toastTitle,
                        variant: 'danger'
                    });
                }
            }).finally(() =>{
                if (loading) {
                    loading(false);
                }
            });
        }
    },
    watch: {
        'productionLine.variety': {
            handler() {
                this.axios.get(getVarietyByIdUrl(this.productionLine.variety.value)).then(response => {
                    let variety = response.data.variety;
                    this.productionLine.parentalFemaleName = variety.parentalFemale;
                    this.productionLine.parentalMaleName = variety.parentalMale;
                    this.productionLine.cropFamily = variety.crop;
                    this.productionLine.crop = variety.crop;
                    this.productionLine.parentalMaleId = variety.parentalMaleId;
                    this.productionLine.parentalFemaleId = variety.parentalFemaleId;
                }).catch(error => {
                    if (error.response) {
                        this.$bvToast.toast(error.response.data.message, {
                            title: this.toastTitle,
                            variant: 'danger'
                        });
                    } else if (error.request) {
                        this.$bvToast.toast('An error occurred while executing the request', {
                            title: this.toastTitle,
                            variant: 'danger'
                        });
                    } else {
                        this.$bvToast.toast('An error occurred while configuring the request', {
                            title: this.toastTitle,
                            variant: 'danger'
                        });
                    }
                });
            },
            deep: true
        },
        'productionLine.femalePlantsMx': {
            handler() {
                this.productionLine.totalPlants = Number(this.productionLine.femalePlantsMx) + Number(this.productionLine.malesNeeded);
                
                if (this.productionLine.femalePlantsMx && this.productionLine.malesNeeded) {
                    this.productionLine.malePerFemaleRatio = (Number(this.productionLine.femalePlantsMx) / Number(this.productionLine.malesNeeded)).toFixed(2);
                } else {
                    this.productionLine.malePerFemaleRatio = '';
                }
            },
            deep:true
        },
        'productionLine.malesNeeded': {
            handler() {
                this.productionLine.totalPlants = Number(this.productionLine.femalePlantsMx) + Number(this.productionLine.malesNeeded);

                if (this.productionLine.femalePlantsMx && this.productionLine.malesNeeded) {
                    this.productionLine.malePerFemaleRatio = (Number(this.productionLine.femalePlantsMx) / Number(this.productionLine.malesNeeded)).toFixed(2);
                } else {
                    this.productionLine.malePerFemaleRatio = '';
                }
            },
            deep:true
        },
        'productionLine.location' : {
            handler() {
                let $this = this;
                let rowsRequiredFemale = 0;
                let rowsRequiredMale = 0;
                let totalRowsRequired = 0;
                let totalSurfaceRequired = 0;

                this.productionLine.location.forEach(function(item) {  
                    if (item.rowsRequiredFemale && item.rowsRequiredMale) {
                        rowsRequiredFemale = rowsRequiredFemale + Number(item.rowsRequiredFemale);
                        rowsRequiredMale = rowsRequiredMale + Number(item.rowsRequiredMale);
                        totalRowsRequired = totalRowsRequired + Number(item.totalRowsRequired);
                        totalSurfaceRequired = totalSurfaceRequired + (Number(item.totalRowsRequired) * Number(item.compartmentRowNetSurface)); 
                    } else if (item.isLegacy) {
                        item.totalRowsRequired = Number($this.productionLine.rowsRequired).toFixed(2);
                        item.surfaceRequired = Number($this.productionLine.surfaceRequired).toFixed(2); 
                        totalRowsRequired = totalRowsRequired + Number(item.totalRowsRequired);
                        totalSurfaceRequired = totalSurfaceRequired + Number(item.surfaceRequired); 
                        rowsRequiredFemale = null;
                        rowsRequiredMale = null;
                    }
                });

                this.productionLine.rowsRequiredFemale = rowsRequiredFemale ? rowsRequiredFemale.toFixed(2) : null;
                this.productionLine.rowsRequiredMale = rowsRequiredMale ? rowsRequiredMale.toFixed(2) : null;
                this.productionLine.rowsRequired = totalRowsRequired.toFixed(2);
                this.productionLine.surfaceRequired =  totalSurfaceRequired.toFixed(2);
            },
            deep:true
        }
    }
};
</script>